import * as yup from "yup";

/**
 * Validation for the anonymous supplier offer (`/order-invitations/:token`). Extracted from the
 * pre-Carbon `AnonymousOffer` so it can be shared with the split section components and unit-tested.
 * Rules are unchanged from the original inline schema: supplier email + taxId + positive price +
 * positive quantity are required; everything else is optional.
 */
/** An optional number left blank: the field holds "", which yup would otherwise reject as NaN. */
const optionalNumber = () =>
  yup
    .number()
    .transform((value: number, original: unknown) =>
      original === "" ? undefined : value
    )
    .optional();

export const makeAnonymousOfferSchema = (buyerPicksUp = false) =>
  yup.object({
  email: yup.string().email().required(),
  taxId: yup.string().required(),
  companyName: yup.string().optional(),
  price: yup.number().positive().required(),
  quantity: yup.number().positive().required(),
  discount: optionalNumber(),
  deliveryCost: optionalNumber(),
  deliveryDate: yup.string().optional(),
  expireDate: yup.string().optional(),
  offerValidity: yup.string().optional(),
  paymentTerm: yup.string().optional(),
  paymentMethod: yup.string().optional(),
  leadTime: yup.string().optional(),
  currency: yup.string().optional(),
  deliveryFormat: yup.string().optional(),
  comment: yup.string().optional(),
  generalComments: yup.string().optional(),
  // SCRUM-70: on an order the buyer picks up, the supplier says where to collect.
  pickupAddress: buyerPicksUp
    ? yup.string().trim().required()
    : yup.string().optional(),
});

export const anonymousOfferSchema = makeAnonymousOfferSchema();

export interface AnonymousOfferFormValues {
  email: string;
  taxId: string;
  companyName?: string;
  price: number;
  quantity: number;
  discount?: number;
  deliveryCost?: number;
  deliveryDate?: string;
  expireDate?: string;
  offerValidity?: string;
  paymentTerm?: string;
  paymentMethod?: string;
  leadTime?: string;
  currency?: string;
  deliveryFormat?: string;
  comment?: string;
  generalComments?: string;
  pickupAddress?: string;
}
